{
  "app": {
    "shellTitle": "Dink Product Admin · Platform Console",
    "loading": "Loading"
  },
  "common": {
    "retry": "Retry",
    "close": "Close",
    "menu": "Menu",
    "loading": "Loading",
    "language": "Language",
    "comingSoon": "Coming soon",
    "noProgress": "No progress"
  },
  "lang": { "en": "EN", "es": "ES", "fr": "FR", "pt": "PT" },
  "language_switcher": {
    "label": "Language",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "signOut": "Sign out",
    "signIn": "Sign in",
    "group": { "operations": "Operations", "configuration": "Configuration" },
    "dashboard": "Dashboard",
    "queue": "Queue",
    "notifications": "Notifications",
    "logs": "Logs",
    "tenants": "Tenants",
    "engine": "Engine",
    "globalConfig": "Global config"
  },
  "shell": {
    "scope": "Platform — all tenants",
    "notificationsAriaLabel": "Notifications",
    "accountMenu": "Account"
  },
  "page": {
    "dashboard": { "title": "Dashboard" },
    "queue": { "title": "Queue" },
    "notifications": { "title": "Notifications" },
    "logs": { "title": "Logs" },
    "tenants": { "title": "Tenants" },
    "engine": { "title": "Engine" },
    "globalConfig": { "title": "Global config" }
  },
  "bootstrap": {
    "error": "Could not load application configuration.",
    "errorNotRegistered": "This host is not registered. Contact your administrator.",
    "retry": "Retry"
  },
  "auth": {
    "redirecting": "Redirecting to sign in…",
    "returning": "Completing sign-in…",
    "noAccessTitle": "You don't have access to this console",
    "noAccessBody": "Your account is signed in but has not been granted access to this product admin console. Contact your administrator if you believe this is a mistake.",
    "productAdminRequired": "Product admin access required",
    "productAdminRequiredBody": "You're signed in, but your account hasn't been granted access to this product admin console.",
    "signedOutTitle": "You're signed out",
    "signedOutBody": "Your product-admin session has ended.",
    "signInAgain": "Sign in again"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Network error. Check your connection and try again.",
    "notFoundTitle": "Not found",
    "notFoundBody": "We couldn't find what you were looking for."
  },
  "help": {
    "ariaLabel": "Help for {{label}}"
  }
}
